import React from 'react';
import Toast from './Toast';
import { useNotify } from '../../context/NotificationContext';

export default function ToastContainer() {
  const { toasts, remove } = useNotify();
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <Toast key={t.id} toast={t} onClose={() => remove(t.id)} />
      ))}
    </div>
  );
}
